import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const VerificationContext = createContext();

// const BASE_URL = "http://localhost:8000";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const VerificationProvider = ({ children }) => {
  const [email, setEmail] = useState(null);
  const [isVerified, setIsVerified] = useState(false);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (!email) return;

    setChecking(true);

    const interval = setInterval(async () => {
      try {
        const res = await axios.get(`${BASE_URL}/api/auth/check-verification`, {
          params: { email },
        });

        if (res.data.verified) {
          setIsVerified(true);
          setChecking(false);
          clearInterval(interval);
        }
      } catch (err) {
        // silent fail
      }
    }, 2000);

    return () => clearInterval(interval);
  }, [email]);

  const startVerificationWatch = (userEmail) => {
    setEmail(userEmail);
    setIsVerified(false);
  };

  return (
    <VerificationContext.Provider
      value={{
        startVerificationWatch,
        isVerified,
        checking,
      }}
    >
      {children}
    </VerificationContext.Provider>
  );
};

export const useVerification = () => {
  const context = useContext(VerificationContext);
  if (!context) {
    throw new Error("useVerification must be used inside VerificationProvider");
  }
  return context;
};
